import { computed, unref } from 'vue'
import { useDisplay } from 'vuetify'

export function useMobileMd() {
    const display = useDisplay();

    return computed(() => {
      return unref(display.md)
    });
}